import { useMemo } from 'react';

/**
 * Custom hook to retrieve environment variables.
 * @returns {Object} - An object containing the environment variables.
 */
const useEnv = (): { baseUrl: string | undefined; cloudUrl: string | undefined } =>
  useMemo(
    () => ({
      baseUrl: process.env.REACT_APP_BASE_URL,
      cloudUrl: process.env.REACT_APP_CLOUD_URL,
    }),
    [],
  );

export default useEnv;
